import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import type { CollectDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import ReadOnlyForm from './components/read-only-form';
type CustomRequirementsSectionProps = {
  node: CollectDataNodeProps;
};

/** Read-only view of custom data requirements. Since customRequirements is deprecated on CollectData nodes, we don't need to support editing here. Once an edit session starts, the backend will rewrite these as CollectCustomData nodes. */
const CustomRequirementsSection = t0 => {
  const $ = _c(10);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const customReqsPages = node.data.customRequirements;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== customReqsPages) {
    t3 = customReqsPages.map(_temp2);
    $[3] = customReqsPages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex flex-col gap-4">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Section title={t2}>{t4}</Section>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default CustomRequirementsSection;
function _temp($) {
  return $.label;
}
function _temp2(page) {
  return <ReadOnlyForm key={page.header} page={page} />;
}